import React, { useRef, useState } from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

import cn from 'src/classnames';
import { useTranslation } from 'src/i18n';
import { TP } from 'constants/consts';
// import StaatsoperetteSrc from 'public/images/companies/staatsoperette.png';
import BayerischeStaatsopeSrc from 'public/images/companies/Bayerische.png';
import MetoperaSrc from 'public/images/companies/metopera.png';
import TeatrorealSrc from 'public/images/companies/teatroreal.png';
import TeatroallascalaSrc from 'public/images/companies/teatroallascala.png';
import MozartSrc from 'public/images/companies/mozart.png';
import DeutscheoperberlinSrc from 'public/images/companies/deutscheoperberlin.png';
import RohSrc from 'public/images/companies/roh.png';
import SalzburgerfestspieleSrc from 'public/images/companies/salzburgerfestspiele.png';
import OperadeparisSrc from 'public/images/companies/operadeparis.png';
import ImageTag from 'components/ImageTag';
import styles from './ArtistCompanies.module.scss';

export const COMPANIES_LIST = [
  // { src: StaatsoperetteSrc, href: 'https://www.staatsoperette.de/' },
  { src: BayerischeStaatsopeSrc, href: '/companies/germany/bayerische-staatsoper-230' },
  { src: MetoperaSrc, href: '/companies/united-states/the-metropolitan-opera-1496' },
  { src: TeatrorealSrc, href: '/companies/spain/teatro-real-de-madrid-454' },
  { src: TeatroallascalaSrc, href: '/companies/italy/teatro-alla-scala-706' },
  { src: MozartSrc, href: '/companies/austria/wiener-staatsoper-51' },
  { src: DeutscheoperberlinSrc, href: '/companies/germany/deutsche-oper-berlin-246' },
  { src: RohSrc, href: '/companies/united-kingdom/royal-opera-house-1205' },
  { src: SalzburgerfestspieleSrc, href: '/companies/austria/salzburger-festspiele-35' },
  { src: OperadeparisSrc, href: '/companies/france/opera-national-de-paris-534' },
];

const ArtistCompanies = ({ withArrows }) => {
  const { t } = useTranslation();
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const listsRef = useRef();

  const leftScroll = () => {
    listsRef.current.scrollBy(-100, 0);
    if (!showRightArrow) {
      setShowRightArrow(true);
    }
    if (listsRef.current.scrollLeft < 50) {
      setShowLeftArrow(false);
    }
  };

  const rightScroll = () => {
    listsRef.current.scrollBy(100, 0);
    if (listsRef.current.scrollLeft > 0 && !showLeftArrow) {
      setShowLeftArrow(true);
    }
    if (listsRef.current.scrollLeft + listsRef.current.clientWidth > listsRef.current.scrollWidth - 30) {
      setShowRightArrow(false);
    }
  };

  return (
    <div className={cn(styles.wrapper, styles.withArrow)}>
      <div className={styles.title}>{t(`${TP}.LANDING_PAGE_TRUSTED_COMPANIES`)}</div>
      <div className={styles.list}>
        {withArrows && showLeftArrow && (
          <button className={styles.left} onClick={leftScroll} type="button">
            <KeyboardArrowLeftIcon />
          </button>
        )}
        <div ref={listsRef} className={styles.companiesList}>
          {COMPANIES_LIST.map((company, index) => (
            <a href={company.href} target="_blank" rel="Company link" key={index} className={styles.companyLink}>
              <ImageTag src={company.src} className={styles.companyImage} />
            </a>
          ))}
        </div>

        {withArrows && showRightArrow && (
          <button className={styles.right} onClick={rightScroll} type="button">
            <KeyboardArrowLeftIcon />
          </button>
        )}
      </div>
    </div>
  );
};

export default ArtistCompanies;
